import { FlowInterface, PaymentOptionInterface } from '@pe/checkout/types';

import { roundValue } from './round.util';

export function totalFee(option: PaymentOptionInterface, flow: FlowInterface): number {
  const { fixedFee = 0, variableFee = 0 } = option;

  return roundValue(fixedFee + 0.01 * variableFee * flow.total);
}
